import * as React from 'react'
import {
    List,
    Datagrid,
    TextField,
    DateField,
    FunctionField,
    TextInput,
    DateInput,
    SelectInput
} from 'react-admin'
import { Chip } from '@mui/material'
import { UserConsent } from '@/types'

const ConsentFilters = [
    <TextInput key="token" source="hashed_email" label="Token" alwaysOn />,
    <TextInput key="email" source="user.email" label="Email utilisateur" />,
    <SelectInput 
        key="consent" 
        source="isGranted" 
        label="Statut" 
        choices={[
            { id: true, name: 'Accordé' },
            { id: false, name: 'Révoqué' }
        ]} 
    />,
    <DateInput key="dateFrom" source="createdAt_gte" label="Depuis" />,
    <DateInput key="dateTo" source="createdAt_lte" label="Jusqu'à" />
]

export default function UserConsentList() {
    return (
        <List
            filters={ConsentFilters}
            perPage={25}
            sort={{ field: 'createdAt', order: 'DESC' }}
        >
            <Datagrid bulkActionButtons={false} rowClick="show">
                <TextField source="hashed_email" label="Token" />
                <TextField source="user.email" label="Email utilisateur" />
                <TextField source="user.firstName" label="Prénom" />
                <TextField source="user.lastName" label="Nom" />
                <TextField source="consentPurpose.title" label="Usage RGPD" />
                <FunctionField
                    source="isGranted"
                    label="Statut"
                    render={(record: UserConsent) => (
                        <Chip
                            label={record.isGranted ? 'Accordé' : 'Révoqué'}
                            color={record.isGranted ? 'success' : 'error'}
                            size="small"
                        />
                    )}
                />
                <DateField source="consentedAt" label="Date consentement" showTime />
                <DateField source="revokedAt" label="Date révocation" showTime />
                <DateField source="createdAt" label="Créé le" showTime />
            </Datagrid>
        </List>
    )
}